/* eslint-disable react-hooks/exhaustive-deps */
import {memo, useCallback, useEffect, } from 'react'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../../../components/TextInputV2'
import {Selection} from '../../../../../components/Selection'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {filterSelector, setFilterMasterJBPType} from '../../../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../../../components/Table/Table'
import { useSalesOrganization } from 'src/hooks/useSalesOrganization'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterMasterJBPType: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {salesOrgOptions} = useSalesOrganization(true)

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterMasterJBPType({...filter, ...value}))
  }

  useEffect(() => {
    let _filter = filter
    try{
      let storage = localStorage.getItem('redux-mjbpt-filter') as string

      if (storage) {
        let persisted = JSON.parse(storage)
        _filter = {
          ...filter,
          ...persisted
        }
        dispatch(setFilterMasterJBPType(_filter))
      }

    }catch(e){
      console.log(e)
    }
  }, [])

  return (
    <TRowFilter>
      <td>&nbsp;</td>
      <td>
        <TextInputV2
          placeholder={t('code')}
          value={filter?.code ?? ''}
          onChange={({target}) => handleChange({code: target.value})}
        />
      </td>
      {/* <td>
        <TextInputV2
          placeholder={t('Sales Org Code')}
          value={filter?.company_code ?? ''}
          onChange={({target}) => handleChange({company_code: target.value})}
        />
      </td> */}
      <td>
        <Selection
          data={salesOrgOptions}
          placeholder={t('sub-order-produsen')}
          value={filter?.company_code ?? ''}
          onChange={(sales_org_code) => handleChange({company_code: sales_org_code})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('jbp-type')}
          value={filter?.type ?? ''}
          onChange={({target}) => handleChange({type: target.value})}
        />
      </td>
      <td>&nbsp;</td>
    </TRowFilter>
  )
})
